/**
 * @type {angular}
 */
module.exports = window.angular.module("BrowserSync");



//////////////////
// WEBPACK FOOTER
// ./module.js
// module id = 64
// module chunks = 0